import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";

import styles from "./FormControl.module.scss";

const VARIANTS: { [key: string]: string } = {
  vertical: styles.controlVertical,
  horizontal: styles.controlHorizontal,
};

const FormControl = ({
  className,
  errorClassName,
  children,
  required,
  withVerticalSpace = true,
  controlMultiple = false,
  haveError,
  error,
  variant = "vertical",
  label,
  labelProps,
}: any) => (
  <div
    className={cn(
      styles.control,
      { 
        [styles.controlWithSpace]: withVerticalSpace,
        [styles.controlMultiple]: controlMultiple
      },
      VARIANTS[variant],
      className
    )}
  >
    {label && (
      <Typography
        className={cn(styles.label, { [styles.labelRequired]: required })}
        variant="bodyM"
        {...labelProps}
      >
        {label}
      </Typography>
    )}
    {children}
    {haveError && error && (
      <div className={cn(styles.error, errorClassName)}>
        <Typography className={styles.errorText} variant="bodyXS">
          {error}
        </Typography>
      </div>
    )}
  </div>
);

export default FormControl;
